import { TEAM_USERS_RECEIVED } from '../../actions/GetTeamUsers';

const initialState = {
  teamId: null,
  users: [],
};

const teamUsers = (state = initialState, action) => {
  switch (action.type) {
    case TEAM_USERS_RECEIVED:
      return {
        teamId: action.teamId,
        users: action.users,
      };
  }

  return state;
};

export default teamUsers;

